<template>
	<ul :id="listId" class="questions-section--row tw-text-app-color-font">
		<li
			class="tw-flex tw-gap-4 tw-items-center tw-justify-between tw-px-4 tw-py-2"
			v-for="(questionItem, index) in questions"
			:key="keyRender + index"
		>
			<p-drag-handle class="sort-handler"></p-drag-handle>
			<div class="tw-flex-auto">
				{{ questionItem.description }}
			</div>
			<edit-icon
				style="width: 20px;"
				class="cursor-pointer"
				@click="$emit('editClicked', questionItem)"></edit-icon>
			<close-icon
				style="width: 20px"
				class="cursor-pointer"
				@click="$emit('removeClicked', questionItem)"
			></close-icon>
		</li>
	</ul>
</template>

<script>
import PDragHandle from '@/modules/shared/components/ui/p-drag-handler';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import EditIcon from '@/modules/shared/components/icons/edit-icon';
import { genId } from '@/modules/shared/utils/uuid';
import Sortable from 'sortablejs';
import { move } from 'ramda';

export default {
	name: 'subfactor-sortable-list',
	data() {
		return {
			listId: '',
			keyRender: 0,
		};
	},
	components: { PDragHandle, CloseIcon, EditIcon },
	created() {
	},
	mounted() {
		this.listId = genId();
		setTimeout(() => {
			this.initSortable();
		});
	},
	methods: {
		initSortable() {
			const table = document.getElementById(this.listId);
			this.$sortable = new Sortable(table, {
				handle: '.sort-handler',
				animation: 150,
				onEnd: event => this.applySortChanges(event),
			});
		},
		applySortChanges({ oldIndex, newIndex }) {
			const updatedQuestions = move(oldIndex, newIndex, this.questions);
			this.$emit('onSortedQuestionsChange', updatedQuestions);
		},
	},
	watch: {
		questions: {
			handler() {
				this.keyRender = this.keyRender + 9;
			},
			deep: true,
		},
	},
	props: ['questions'],
};
</script>

<style lang="scss" scoped>
.questions-section--row {
	list-style: none;
	padding: 0;
	li {
		border-bottom: 1px solid var(--app-color-gray);
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/questions-sortable-list.vue